import { queryKeys } from '@/lib/query-keys';
import { apiClient } from '@borradh-workspace/api-client';
import { queryOptions, useQuery } from '@tanstack/react-query';
import type { MessagingPlatform } from '../types';

export interface ConversationTabCounts {
  from_ads: number;
  needs_reply: number;
  in_conversation: number;
  cold: number;
  all: number;
}

export const conversationTabCountsQueryOptions = (
  platform?: MessagingPlatform
) =>
  queryOptions({
    // Under the `conversations` prefix so opening a thread (mark read) and
    // sending a reply refresh the badges along with the list.
    queryKey: queryKeys.conversations.tabCounts(platform),
    queryFn: () =>
      apiClient.get<ConversationTabCounts>(
        `conversations/tab-counts${platform ? `?platform=${platform}` : ''}`
      ),
    staleTime: 30 * 1000,
    // The sidebar badge is on every page, so it has to notice new customers
    // without a navigation.
    refetchInterval: 60 * 1000,
  });

export const useConversationTabCounts = (platform?: MessagingPlatform) => {
  const query = useQuery(conversationTabCountsQueryOptions(platform));
  return {
    counts: query.data ?? null,
    isLoading: query.isLoading,
  };
};
